import React from 'react'
import { useLocation, Link } from 'react-router-dom'
import { modules } from '@/modules/registry'

export function Breadcrumbs() {
  const location = useLocation()
  const parts = location.pathname.split('/').filter(Boolean)

  if (parts[0] !== 'dashboard' || parts.length <= 2) return null

  const mod = modules.find((m) => m.basePath === `/dashboard/${parts[1]}`)
  const sidebarEntry = mod?.sidebar.find((r) => r.path === location.pathname)

  const crumbs: { label: string; path: string }[] = []

  if (mod) crumbs.push({ label: mod.name, path: mod.basePath })
  if (sidebarEntry && sidebarEntry.path !== mod?.basePath) {
    crumbs.push({ label: sidebarEntry.label, path: sidebarEntry.path })
  } else if (parts.length > 3) {
    // Dynamic detail route
    crumbs.push({ label: parts[parts.length - 1], path: location.pathname })
  }

  if (crumbs.length <= 1) return null

  return (
    <nav className="flex items-center gap-1.5 text-small text-text-dim mb-4" aria-label="Breadcrumbs">
      {crumbs.map((crumb, i) => (
        <React.Fragment key={crumb.path}>
          {i > 0 && <span className="text-tiny">/</span>}
          {i < crumbs.length - 1 ? (
            <Link to={crumb.path} className="hover:text-text transition-colors">
              {crumb.label}
            </Link>
          ) : (
            <span className="text-text">{crumb.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  )
}
